import { useState } from "react";
import { Navigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { Logo } from "../components/Logo";
import { useAuth, formatApiError } from "../context/AuthContext";
import { inputClass, labelClass } from "./fields";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin/aanvragen" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main data-testid="admin-login-page" className="flex min-h-screen items-center justify-center bg-[#111111] px-4">
      <div className="w-full max-w-sm border border-white/10 bg-white p-8">
        <Logo compact />
        <div className="mt-8 flex items-center gap-2">
          <Lock className="h-4 w-4 text-[#8E8D8A]" />
          <h1 className="font-display text-xl font-bold uppercase tracking-wide text-[#111111]">Beheer inloggen</h1>
        </div>
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="admin-login-form">
          <div>
            <label htmlFor="admin-email" className={labelClass}>E-mailadres</label>
            <input id="admin-email" data-testid="admin-login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputClass} autoComplete="username" />
          </div>
          <div>
            <label htmlFor="admin-password" className={labelClass}>Wachtwoord</label>
            <input id="admin-password" data-testid="admin-login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={inputClass} autoComplete="current-password" />
          </div>
          {error && (
            <p data-testid="admin-login-error" className="border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">{error}</p>
          )}
          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={busy}
            className="w-full rounded-[4px] bg-cream px-6 py-3 font-display text-sm font-bold uppercase tracking-wide text-[#111111] transition-colors duration-200 hover:bg-cream-deep disabled:opacity-70"
          >
            {busy ? "Bezig..." : "Inloggen"}
          </button>
        </form>
        <p className="mt-6 text-center text-[11px] uppercase tracking-[0.2em] text-[#8E8D8A]">Gemaakt door @db_0226</p>
      </div>
    </main>
  );
}
